import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=3116a8a3&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3116a8a3",
  null
  
)

export default component.exports